import { NOTIFICATION, ORG_INVITES_URL } from '@/lib/constants';
import { FullUserNotificationModel } from '@/lib/models/notification/types';
import { getTrackingDetailUrl } from '@/lib/models/tracking-request/utils/get-detail-url';

interface UserNotificationAction {
  label: string;
  href: string;
}

export const getUserNotificationAction = (
  userNotification: FullUserNotificationModel,
): UserNotificationAction | undefined => {
  switch (userNotification.notification.group) {
    case NOTIFICATION.GROUP.TRACKING: {
      if (userNotification.notification.topic === NOTIFICATION.TOPIC.TRACKING.SHIPMENT_UNTRACKABLE) {
        return undefined;
      }
      return {
        label: 'View shipment',
        href: getTrackingDetailUrl(userNotification.notification.context.trackingNumber || ''),
      };
    }
    case NOTIFICATION.GROUP.INVITE: {
      return {
        label: 'View invite',
        href: ORG_INVITES_URL,
      };
    }
    default:
      return undefined;
  }
};
